import React from 'react';
import { Link } from 'react-router-dom';
import { getAuthorDisplayName } from '../../utils/displayName';

/**
 * Clickable author name that navigates to the public profile.
 * Falls back to plain text when no user id is available.
 */
export default function AuthorNameLink({
  user,
  userId,
  children,
  style = {},
  className,
}) {
  const id = userId ?? user?.user_id ?? user?.id ?? null;
  const name =
    children != null && children !== false
      ? children
      : getAuthorDisplayName(user);

  const linkStyle = {
    color: 'inherit',
    textDecoration: 'none',
    fontWeight: 'inherit',
    cursor: id ? 'pointer' : 'default',
    ...style,
  };

  if (!id) {
    return (
      <span className={className} style={linkStyle}>
        {name}
      </span>
    );
  }

  return (
    <Link
      to={`/profile/${id}`}
      className={className}
      style={linkStyle}
      onClick={(e) => e.stopPropagation()}
      onMouseEnter={(e) => {
        e.currentTarget.style.textDecoration = 'underline';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.textDecoration = 'none';
      }}
      title="View profile"
    >
      {name}
    </Link>
  );
}
